import { render, staticRenderFns } from "./DoctorSurgeriesHistory.vue?vue&type=template&id=0ecbca40&scoped=true"
import script from "./DoctorSurgeriesHistory.vue?vue&type=script&lang=js"
export * from "./DoctorSurgeriesHistory.vue?vue&type=script&lang=js"
import style0 from "./DoctorSurgeriesHistory.vue?vue&type=style&index=0&id=0ecbca40&prod&scoped=true&lang=css"
import style1 from "./DoctorSurgeriesHistory.vue?vue&type=style&index=1&id=0ecbca40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecbca40",
  null
  
)

export default component.exports